// src/hooks/useMatomoTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '../context/CookieConsentContext';

export const useMatomoTracking = (additionalData = {}) => {
  //const hasTracked = useRef(false);
  const location = useLocation();

  const { cookiePreferences } = useCookieConsent();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (window._mtm) {
        // 🎯 IMMER TRACKEN - unabhängig von Cookie-Consent
        // Cookieless Tracking funktioniert immer, Cookies nur bei Einwilligung

        const eventData = {
          event: 'react-pageview-matomo',
          CustomReactPageTitle: document.title,
          CustomReactPageUrl: window.location.href,
          // Tracking-Modus Info für Tag Manager
          trackingMode: cookiePreferences.analytics === true ? 'with-cookies' : 'cookieless',
          cookieConsent: cookiePreferences.analytics,
          ...additionalData,
        };
        window._mtm.push(eventData);
      } else {
        console.error('Ein Fehler ist aufgetreten.');
      }
    }, 100);

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, cookiePreferences.analytics]); // Nur bei URL- oder Cookie-Änderung
};
